/**
 * 【KYMW1400】コマ割情報ロックVO
 *
 * @export LockKomaEditModel
 * @class LockKomaEditModel
 */
export class LockKomaEditModel {
  /**
   * 受注コード
   */
  public orderCode = String('');

  /**
   * 媒体区分
   */
  public mediumType = String('');

  /**
   * 生協コード
   */
  public coopCode = String('');

  /**
   *  ページID
   */
  public pageID = Number(0);

  /**
   *  ページ番号
   */
  public pageNum = Number(0);
}
